/**
 * The per-stage scalars every Era 1 line module shares (spec 0037).
 *
 * `validatePool` requires these to be equal across a pool's modules, because a
 * composed stage takes the shared value rather than summing (spec 0034 OQ3).
 * Every number here is a PLACEHOLDER (spec 0037 "Numbers"): it is Tyrian
 * Purple's shipped scalar set, except `minPurity`, chosen loose enough that a
 * Budget feed's impurities do not decide a stage on their own. NEEDS PLAYTEST.
 */
export const ERA_1_SCALARS = {
  ticksPerTurn: 8,
  maxTurns: 6,
  energyBudgetKw: 6,
  handSize: 5,
  minPurity: 70,
  /**
   * Spec 0067 "Numbers": live building during Play. Every field is a PLACEHOLDER
   * needing playtest; `spillFreeMovesPerTurn` is a hook for a follow-up spec and
   * stays 0. Authored once so `validatePool` can require every module to agree.
   */
  liveBuild: {
    installLabourKw: 1,
    dismantleLabourKw: 1,
    moveLabourKw: 1,
    moveCostCredits: 0,
    playRefundPct: 50,
    cleanFeeCredits: 10,
    spillFreeMovesPerTurn: 0,
  },
} as const;
